<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px">
        <v-row>
          <v-col cols="12" class="pa-8">
            <v-btn 
              :to="{ name: 'newProgramEdition', params: { edition_id: this.edition_id } }"
              color="primary">
              Nuevo Día
            </v-btn>
          </v-col>

          <v-col cols="12">
            <v-data-table
              class="pt-8"
              :headers="headers"
              :items="program"
              :custom-filter="customSearch"
              :items-per-page="30"
              :header-props="headerProps"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, 100],
                'items-per-page-text':'Actividades por página',
              }"
              mobile="true"
            >
            <template v-slot:item.date="{ item }">
              {{ convertDate(item.date) }}
            </template>
              <template v-slot:item.actions="{ item }">
                <td class="text-center">
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="info"
                    :to="{ name: 'activitiesProgramEdition', params: {edition_id: edition_id, program_id: item.id } }"
                  >
                    <v-icon dark small>
                      mdi-format-list-bulleted
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="primary"
                    :to="{ name: 'showProgramEdition', params: {edition_id: edition_id, program_id: item.id } }"
                  >
                    <v-icon dark small>
                      mdi-eye
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="warning"
                    :to="{ name: 'editProgramEdition', params: {edition_id: edition_id, program_id: item.id } }"
                  >
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="red"
                    @click="confirmDeleteActivity(item.id)"
                  >
                    <v-icon dark small>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>
   
    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'editEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        color="primary"
        :to="{ name: 'showAllProgramEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-eye
        </v-icon>
        Vista previa
      </v-btn>
    </v-col>

    <v-dialog
      v-model="dialog_delete"
      width="500">
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Atención 
        </v-card-title>

        <v-card-text class="pt-4 pb-6">
          ¿Está seguro que desea borrar a este día? Toda la información
          vinculada a él se borrara tambíen.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_delete = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="loading_btn"
            @click="deleteActivity()"
          >
            Borrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'programEdition',

    data: () => ({
      loading:true,
      loading_btn:false,
      dialog_delete: false,
      delete_id:null,

      program:[],

      headerProps: {
        sortByText: "Ordenar por"
      },
      headers: [
      {
          text: 'Fecha',
          align: 'center',
          sortable: true,
          value: 'date',
          width: '15%'
        },
        {
          text: 'Nombre del día',
          align: 'start',
          sortable: true,
          value: 'name',
          width: '60%'
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '25%'
        }
      ],
      attrs: {
        boilerplate: false,
      },
    }),

    methods:{
      customSearch (value, search, item) {
          return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search))
      },
      
      filterOnlyCapsText (value, search, item) {
        console.log(item)
        return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLocaleUpperCase().indexOf(search) !== -1
      },

      convertDate(date) {
        const parts = date.split('-');
        const day = parts[2];
        const month = parts[1];
        const year = parts[0];

        return `${day}/${month}/${year}`;
      },

      async getprogramEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/program-edition').then(response =>{
          this.program = response.data.data.program
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      confirmDeleteActivity(id)
      {
        this.dialog_delete = true
        this.delete_id = id
      },

      async deleteActivity()
      {
        this.loading_btn = true
        try {  
          await axios.delete('admin/editions/'+this.edition_id+'/program-edition/'+this.delete_id).then(() =>{
            this.dialog_delete = false
            this.loading_btn =false
            this.loading=true
            this.delete_id = null
            this.loading = true
            this.getprogramEdition()
          })
        } catch (error) {
          console.error(error.response.data);
        }
      },
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getprogramEdition()
    },
  }
</script>
